import https from "@/lib/https";
import type {
  SkillDetail,
  SkillPayload,
  GetSkillListParams,
} from "@/interface/masterManagement";
import type { ApiResponse, PaginationResponse } from "@/interface/common";

const BASE_URL = "/api/master/skills/";

export const getSkillList = async (
  params: GetSkillListParams,
): Promise<ApiResponse<PaginationResponse<SkillDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<SkillDetail>>>(
    BASE_URL,
    params,
  );
};

export const getSkillsByCategoryId = async (
  categoryId: number | string,
  params?: GetSkillListParams,
): Promise<ApiResponse<PaginationResponse<SkillDetail>>> => {
  return await https.get<ApiResponse<PaginationResponse<SkillDetail>>>(
    `${BASE_URL}${categoryId}/`,
    { ...params },
  );
};

export const createSkill = async (
  payload: SkillPayload,
): Promise<ApiResponse<SkillDetail>> => {
  return await https.post<ApiResponse<SkillDetail>>(BASE_URL, payload);
};

export const updateSkill = async (
  id: number | string,
  payload: SkillPayload,
): Promise<ApiResponse<SkillDetail>> => {
  return await https.put<ApiResponse<SkillDetail>>(
    `${BASE_URL}${id}/`,
    payload,
  );
};

export const deleteSkill = async (
  id: number | string,
): Promise<ApiResponse<void>> => {
  return await https.delete<ApiResponse<void>>(`${BASE_URL}${id}/`);
};
